<template>
  <b-row class="border-bottom pb-3">
    <b-col cols="6" sm="12" md="6" class="custom-border-representant">
      <div class="d-flex justify-content-center align-items-center h-100 py-2">
        <font-awesome-icon icon="user-tag" size="lg" />
        <div class="mx-2">
          {{ nbOfRepresentedMandates }} / {{ votingLimitRules.votesLimitPerMandate }}
        </div>
        <b-badge :variant="votesLimitResult < 0 ? 'danger' : 'info'">
          {{ votesLimitResult }}
        </b-badge>
      </div>
      <div class="border-right"></div>
    </b-col>
    <b-col cols="6" sm="12" md="6">
      <div class="d-flex justify-content-center align-items-center h-100 py-2">
        <font-awesome-icon icon="vote-yea" size="lg" />
        <div class="mx-2">
          {{ nbOfRepresentedTantiemes }} / {{ votingLimitRules.tantiemesLimitPerMandate }}
        </div>
        <b-badge :variant="tantiemesLimitResult < 0 ? 'danger' : 'info'">
          {{ tantiemesLimitResult }}
        </b-badge>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ["nbOfRepresentedMandates", "nbOfRepresentedTantiemes"],
  computed: {
    votesLimitResult() {
      var x = this.votingLimitRules.votesLimitPerMandate - this.nbOfRepresentedMandates;
      return x.toFixed();
    },
    tantiemesLimitResult() {
      var x = this.votingLimitRules.tantiemesLimitPerMandate - this.nbOfRepresentedTantiemes;
      return this.formatNumber(x);
    },
  },
};
</script>
